import { render, staticRenderFns } from "./BluebeamConnect.vue?vue&type=template&id=2d07ddd7&scoped=true"
import script from "./BluebeamConnect.vue?vue&type=script&lang=ts"
export * from "./BluebeamConnect.vue?vue&type=script&lang=ts"
import style0 from "./BluebeamConnect.vue?vue&type=style&index=0&id=2d07ddd7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d07ddd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d07ddd7')) {
      api.createRecord('2d07ddd7', component.options)
    } else {
      api.reload('2d07ddd7', component.options)
    }
    module.hot.accept("./BluebeamConnect.vue?vue&type=template&id=2d07ddd7&scoped=true", function () {
      api.rerender('2d07ddd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BluebeamConnect.vue"
export default component.exports